import React from 'react';
import {Link} from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
const Cta = () => {
    return ( 
        <div className="w-full flex items-center justify-center text-gray-100 cta lg:px-25 lg:text-2xl ">
            <div className="mx-8 h-96 text-center lg:text-left py-16 px-12 flex lg:justify-center sm:items-center items-center">                    
                <div className="w-full flex flex-col lg:flex-row">
                    <div className="mb-4">
                        <p className='text-2xl sm:text-4xl font-bold mb-4 '>Contact Me</p>
                        <p className="text-lg sm:text-2xl lg:pr-6">I’m always interested in new projects, collaborations, and challenges in frontend website development. Feel free to reach out</p>
                    </div>
                    
                    <div className=" w-full flex justify-center sm:items-center lg:w-70 pt-6 ml-9 lg:pr-8 lg:text-lg">
                        <HashLink className=" sm:w-auto lg:w-70 border border-gray-100 hover:bg-[#b54a73] hover:border-[#b25d7e]  text-gray-100 rounded-lg px-6 py-3 items-center justify-center space-x-2 flex active:bg-[#b25d7e] active:border-[#8c3e5d] active:shadow-lg" smooth to="/#contact">Send Message
                        <svg className="w-5 h-5 ml-1 group-hover:translate-x-2 duration-500 ease-in" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                        </HashLink>
                    </div>
                </div>
            </div>
        </div>
     );
}
 
export default Cta;